import React from 'react';

type LibraryAdvancedToggleProps = Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'children' | 'type'> & {
  active?: boolean;
  expanded: boolean;
  label?: string;
};

export function LibraryAdvancedToggle({
  active = false,
  className,
  expanded,
  label = 'Advanced',
  ...buttonProps
}: LibraryAdvancedToggleProps) {
  const classes = className
    ? `library-toolbar__advanced-toggle ${className}`
    : 'library-toolbar__advanced-toggle';

  return (
    <button
      {...buttonProps}
      type="button"
      className={classes}
      aria-expanded={expanded}
      data-active={active ? 'true' : 'false'}
    >
      <span>{label}</span>
      <svg
        className="library-toolbar__advanced-toggle-icon"
        aria-hidden="true"
        width="14"
        height="14"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="m6 9 6 6 6-6" />
      </svg>
    </button>
  );
}

export default LibraryAdvancedToggle;
